import {
    Grid,
    Typography,
    Button,
    ButtonGroup,
    TextField
} from '@material-ui/core'
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import React, { ReactElement } from 'react'
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { globalStyles } from '../../assets/globalStyles';
import DateFnsUtils from "@date-io/date-fns";
import { selectDate } from '../konfiguration/konfigurationSlice';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import { addTimezoneOffset, subtractTimezoneOffset } from '../../utils/utils';
import {
    setStartDatumTemp, selectStartDatumTemp, selectEndeDatumTemp,
    setStartCounterTemp, setEndeCounterTemp, selectStartCounterTemp, selectEndeCounterTemp,
    handleDecrementStart, handleIncrementStart, switchEndeZeitraum, switchStartZeitraum, switchEndeZeitraumJahre, switchStartZeitraumJahre, 
    selectStartZeitraumTemp, selectEndeZeitraumTemp, handleDecrementEnde, handleIncrementEnde, calculateStartDatum,
    setIsChangedZeit,
    calculateEndeDatum,
} from './zeitSlice';
import { useStyles } from './filterStyles';
import { de } from "date-fns/locale";

interface ZeitFilterProps {
    typ?: string;
    jahre?: boolean;
}

export default function ZeitFilter({typ = "", jahre = false}: ZeitFilterProps): ReactElement {
    const dispatch = useAppDispatch();

    const classes = {
        ...useStyles(),
        ...globalStyles(),
    };

    const { datePicker } = useStyles();

    const isUTC = useAppSelector(selectDate);
    const startDatum = useAppSelector(selectStartDatumTemp);
    const endeDatum = useAppSelector(selectEndeDatumTemp);
    const startCounter = useAppSelector(selectStartCounterTemp);
    const endeCounter = useAppSelector(selectEndeCounterTemp);
    const startZeitraum = useAppSelector(selectStartZeitraumTemp);
    const endeZeitraum = useAppSelector(selectEndeZeitraumTemp);

    return (
        <div>
            <Grid item md={12} style={{ marginBottom: "20px" }} />
            <Grid item md={12} style={{ textAlign: 'left' }}>
                <Typography color="primary">
                    Start
                </Typography>
            </Grid>
            <Grid item md={12}>
                <MuiPickersUtilsProvider locale={de} utils={DateFnsUtils}>
                    <KeyboardDatePicker
                        value={isUTC ? addTimezoneOffset(startDatum) : new Date(startDatum)}
                        className={datePicker}
                        format="dd.MM.yyyy"
                        label="Startzeitpunkt"
                        //ampm={false}
                        okLabel="OK"
                        cancelLabel="ABBRECHEN"
                        disableFuture={true}
                        invalidDateMessage={"Das ausgewählte Datum hat ein ungültiges Format."}
                        inputVariant="outlined"
                        onChange={(event) => {
                            dispatch(setStartDatumTemp(isUTC ? subtractTimezoneOffset(new Date(event + "")) : new Date(event + "")));
                            dispatch(setStartCounterTemp(0));
                            dispatch(calculateEndeDatum());
                            dispatch(setIsChangedZeit(true));
                        }}
                    ></KeyboardDatePicker>
                </MuiPickersUtilsProvider>
            </Grid>
            <Grid item md={12} style={{ margin: "20px" }} />
            <Grid item container md={12}>
                <Grid item md={6} style={{ textAlign: 'left' }}>
                    <ButtonGroup size="large" style={{ width: '95%', maxWidth: '95%' }}>
                        <Button
                            fullWidth
                            className={classes.disabledColor}
                            style={{ fontSize: 'large', width: '95%', maxWidth: '95%' }}
                            size='large'
                            onClick={() => {
                                dispatch(handleDecrementStart());
                                dispatch(calculateStartDatum());
                                dispatch(calculateEndeDatum());
                                dispatch(setIsChangedZeit(true));
                            }}
                        >-</Button>

                        <TextField
                            fullWidth
                            className={classes.textFieldBorder}
                            value={startCounter}
                            //type="number"
                            //error={validate(dispatch, setError, resetError, startDatum.toString(), "Zeitraum Beginn")}
                            //helperText={validateHelper(startDatum.toString())}
                            InputProps={{ inputProps: { min: 0 } }}
                            onChange={(event) => {
                                const input = Number(event.target.value.replace(/[^-0-9]/g, ''));
                                dispatch(setStartCounterTemp(input));
                                dispatch(calculateStartDatum());
                                dispatch(calculateEndeDatum());
                                dispatch(setIsChangedZeit(true));
                            }}
                            style={{ fontSize: 'large', width: '150%', maxWidth: '95%' }}
                        />
                        <Button
                            className={classes.disabledColor}
                            fullWidth
                            style={{ fontSize: 'large', width: '95%', maxWidth: '95%' }}
                            disabled={startCounter >= 0}
                            onClick={() => {
                                dispatch(handleIncrementStart());
                                dispatch(calculateStartDatum());
                                dispatch(calculateEndeDatum());
                                dispatch(setIsChangedZeit(true));
                            }}>
                            +
                        </Button>
                    </ButtonGroup>
                </Grid>
                <Grid item md={6} style={{ textAlign: 'right' }}>
                    <ToggleButtonGroup
                        style={{ width: '95%', maxWidth: '95%', minHeight: '100%' }}
                        value={startZeitraum == "Wochen" ? 'left' : 'right'}
                        exclusive
                        onChange={() => {
                            jahre ? dispatch(switchStartZeitraumJahre()) : dispatch(switchStartZeitraum());
                            dispatch(calculateStartDatum());
                            dispatch(calculateEndeDatum());
                            dispatch(setStartCounterTemp(startCounter));
                            dispatch(setIsChangedZeit(true));
                        }}
                        aria-label="text alignment"
                    >
                        <ToggleButton className={classes.buttonZeitraum} value="left" aria-label="left aligned" style={{ width: '95%', maxWidth: '95%' }}>Wochen</ToggleButton>
{jahre ? <ToggleButton className={classes.buttonZeitraum} value="right" aria-label="right aligned" style={{ width: '95%', maxWidth: '95%' }} >Jahre</ToggleButton> : <ToggleButton className={classes.buttonZeitraum} value="right" aria-label="right aligned" style={{ width: '95%', maxWidth: '95%' }} >Tage</ToggleButton>}
                    </ToggleButtonGroup>
                </Grid>
            </Grid>
            <Grid item md={12} style={{ margin: "30px" }} />
            <Grid item md={12} style={{ textAlign: 'left' }}>
                <Typography color="primary">
                    Dauer
                </Typography>
            </Grid>
            <Grid item container md={12} style={{ marginTop: "10px" }}>
                <Grid item md={6} style={{ textAlign: 'left' }}>
                    <ButtonGroup size="large" style={{ width: '95%', maxWidth: '95%' }}>
                        <Button
                            fullWidth
                            className={classes.disabledColor}
                            style={{ fontSize: 'large', minHeight: "100%", width: '95%', maxWidth: '95%' }}
                            disabled={endeCounter <= 0}
                            size='large'
                            onClick={() => {
                                dispatch(handleDecrementEnde());
                                dispatch(calculateEndeDatum());
                                dispatch(setIsChangedZeit(true));
                            }}>
                            -</Button>
                        <TextField
                            fullWidth
                            className={classes.textFieldBorder}
                            value={endeCounter}
                            //type="number"
                            //error={validate(dispatch, setError, resetError, startDatum.toString(), "Zeitraum Beginn")}
                            //helperText={validateHelper(startDatum.toString())}
                            InputProps={{ inputProps: { min: 0 } }}
                            onChange={(event) => {
                                const input = Number(event.target.value.replace(/[^-0-9]/g, ''));
                                dispatch(setEndeCounterTemp(input));
                                dispatch(calculateEndeDatum());
                                dispatch(setIsChangedZeit(true));
                            }}
                            style={{ fontSize: 'large', width: '150%', maxWidth: '95%' }}
                        />
                        <Button
                            className={classes.disabledColor}
                            fullWidth
                            style={{ fontSize: 'large', width: '95%', maxWidth: '95%' }}
                            disabled={endeDatum.getTime() > new Date().getTime()}
                            onClick={() => {
                                dispatch(handleIncrementEnde());
                                dispatch(calculateEndeDatum());
                                dispatch(setIsChangedZeit(true));
                            }}>
                            +
                        </Button>
                    </ButtonGroup>
                </Grid>
                <Grid item md={6} style={{ textAlign: 'right' }}>
                    <ToggleButtonGroup
                        style={{ width: '95%', maxWidth: '95%', minHeight: '100%' }}
                        value={endeZeitraum == "Wochen" ? 'left' : 'right'}
                        exclusive
                        onChange={() => {
                            jahre ? dispatch(switchEndeZeitraumJahre()) : dispatch(switchEndeZeitraum());
                            dispatch(calculateEndeDatum());
                            dispatch(setIsChangedZeit(true));
                        }}
                        aria-label="text alignment"
                    >
                        <ToggleButton
                            className={classes.buttonZeitraum}
                            value="left"
                            aria-label="left aligned"
                            style={{ width: '95%', maxWidth: '95%' }}>
                            Wochen</ToggleButton>
                        {jahre ? <ToggleButton
                            className={classes.buttonZeitraum}
                            value="right"
                            aria-label="right aligned"
                            style={{ width: '95%', maxWidth: '95%' }}
                        >Jahre</ToggleButton> : <ToggleButton
                            className={classes.buttonZeitraum}
                            value="right"
                            aria-label="right aligned"
                            style={{ width: '95%', maxWidth: '95%' }}
                        >Tage</ToggleButton>}
                    </ToggleButtonGroup>
                </Grid>
            </Grid>
        </div>
    );
}